import React, { useEffect, useRef, useState } from 'react';

/**
 * Fallback for Share > Copy Link when the clipboard API is unavailable or refuses (no focus,
 * insecure context): shows the link, pre-selected, with a Copy button that retries.
 */
export default function ShareLinkDialog({ url, onClose, onCopy }) {
  const inputRef = useRef(null);
  const [copied, setCopied] = useState(false);
  useEffect(() => { inputRef.current?.select(); }, [url]);

  const copy = async () => {
    inputRef.current?.select();
    const ok = await onCopy(url);
    setCopied(ok);
  };

  return (
    <div
      role="dialog" aria-modal="true" aria-label="Share link"
      style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.45)', zIndex: 1000, display: 'flex', alignItems: 'center', justifyContent: 'center' }}
      onClick={onClose}
    >
      <div
        className="bg-card border border-border rounded-lg p-5 shadow-lg"
        style={{ width: 'min(560px, 92vw)' }}
        onClick={(e) => e.stopPropagation()}
      >
        <h3 className="text-sm font-semibold mb-1">Share link</h3>
        <p className="text-xs text-muted-foreground mb-3">
          Your browser blocked automatic copying. Copy this link to share the current view.
        </p>
        <input
          ref={inputRef} readOnly value={url} data-testid="share-link-input"
          onFocus={(e) => e.target.select()}
          className="w-full px-3 py-2 border border-input rounded-md text-xs font-mono bg-background"
        />
        <div className="flex justify-end gap-2 mt-3">
          <button onClick={onClose} className="px-3 py-1.5 text-sm border border-border rounded-md hover:bg-muted">Close</button>
          <button onClick={copy} data-testid="share-link-copy" className="px-3 py-1.5 text-sm bg-primary text-primary-foreground rounded-md hover:opacity-90">
            {copied ? 'Copied' : 'Copy'}
          </button>
        </div>
      </div>
    </div>
  );
}
